import { createMemoStyles } from '@wds/utils';
import { HeaderTheme } from '../../theme';

type MenuButtonStyleProps = {
  showMobileNav: boolean;
  left: boolean;
};

const menuButtonLineStyle = {
  position: 'absolute',
  height: '3px',
  width: '24px',
  background: '#fff',
  borderRadius: '2px',
  marginBottom: '6px',
  transition: 'all 0.4s',
};

const useMobileNavStyles = createMemoStyles(({ spacing }: HeaderTheme) => ({
  menuButton: (props: MenuButtonStyleProps) => ({
    position: 'absolute',
    top: '50%',
    ...(props?.left ? { left: spacing[5] } : { right: spacing[5] }),
    transform: 'translateY(-50%)',
    height: '25px',
    width: '26px',
    borderRadius: 0,
    border: 'none',
    boxShadow: 'none',
    background: 'none',
    cursor: 'pointer',
  }),
  menuButtonLineTop: ({ showMobileNav }: MenuButtonStyleProps) => ({
    ...menuButtonLineStyle,
    top: '0px',
    transition: 'all 0.2s',
    opacity: showMobileNav ? 0 : 1,
  }),
  menuButtonLineMiddleLeft: ({ showMobileNav }: MenuButtonStyleProps) => ({
    ...menuButtonLineStyle,
    top: '10px',
    transform: showMobileNav ? 'rotate(225deg)' : null,
    width: showMobileNav ? '26px' : '24px',
  }),
  menuButtonLineMiddleRight: ({ showMobileNav }: MenuButtonStyleProps) => ({
    ...menuButtonLineStyle,
    top: '10px',
    transform: showMobileNav ? 'rotate(135deg)' : null,
    width: showMobileNav ? '26px' : '24px',
    opacity: showMobileNav ? 1 : 0,
  }),
  menuButtonLineBottom: ({ showMobileNav }: MenuButtonStyleProps) => ({
    ...menuButtonLineStyle,
    top: '20px',
    transition: 'all 0.2s',
    opacity: showMobileNav ? 0 : 1,
  }),
}));

export default useMobileNavStyles;
